/**
 * Cart Drawer Recommendations
 * - Variant selection with price updates
 * - When a product is added, it fades out and the next queued product slides in
 * - Prevents double-clicks and handles add-to-cart errors
 * Uses event delegation so it survives cart drawer re-renders.
 */

(function () {
  'use strict';

  /* ---- Money formatting ---- */
  function formatMoney(cents) {
    if (!window.theme || !theme.moneyFormat) {
      return '$' + (cents / 100).toFixed(2);
    }
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100);
    var amountWithComma = amount.replace('.', ',');

    return theme.moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---- Variant select: update price ---- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-rec-variant-select]');
    if (!sel) return;

    var opt = sel.options[sel.selectedIndex];
    var price = parseInt(opt.dataset.price, 10);
    var compare = opt.dataset.comparePrice ? parseInt(opt.dataset.comparePrice, 10) : 0;
    var card = sel.closest('[data-rec-card]');
    var priceEl = card ? card.querySelector('[data-rec-price]') : null;
    if (!priceEl) return;

    if (compare > price) {
      priceEl.innerHTML =
        '<span class="cart-rec__price--sale">' + formatMoney(price) + '</span>' +
        '<s class="cart-rec__price--compare">' + formatMoney(compare) + '</s>';
    } else {
      priceEl.textContent = formatMoney(price);
    }
  });

  /* ---- Swap: fade out added card, reveal next queued card ---- */
  function swapCard(addedCard) {
    var list = addedCard.closest('.cart-rec__list');
    if (!list) return;

    addedCard.classList.add('cart-rec__card--added');

    var queued = list.querySelector('.cart-rec__card--queued');

    setTimeout(function () {
      addedCard.remove();

      if (queued) {
        queued.classList.remove('cart-rec__card--queued');
        queued.classList.add('cart-rec__card--entering');
        queued.style.display = '';

        setTimeout(function () {
          queued.classList.remove('cart-rec__card--entering');
        }, 400);
      }

      var visibleCards = list.querySelectorAll('[data-rec-card]:not(.cart-rec__card--queued):not(.cart-rec__card--added)');
      if (visibleCards.length === 0) {
        var section = list.closest('[data-cart-recommendations]');
        if (section) section.style.display = 'none';
      }
    }, 350);
  }

  /* ---- Listen for add-to-cart clicks on recommendation cards ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    var card = btn.closest('[data-rec-card]');
    if (!card) return;

    // Prevent double-clicks — mark card as processing
    if (card.dataset.recProcessing === 'true') return;
    card.dataset.recProcessing = 'true';

    // Listen for cart errors — if the theme dispatches an error, undo the swap
    var errorOccurred = false;
    function onCartError() {
      errorOccurred = true;
      card.dataset.recProcessing = '';
    }
    document.addEventListener('theme:cart:error', onCartError, { once: true });

    // Give the theme time to process, then check and swap
    setTimeout(function () {
      document.removeEventListener('theme:cart:error', onCartError);

      if (!errorOccurred) {
        swapCard(card);
      }
    }, 900);
  });
})();
